export * as experiences from '@wix/auto_sdk_table-reservations_experiences/schemas';
export * as reservations from '@wix/auto_sdk_table-reservations_reservations/schemas';
export * as reservationLocations from '@wix/auto_sdk_table-reservations_reservation-locations/schemas';
export * as timeSlots from '@wix/auto_sdk_table-reservations_time-slots/schemas';
